import { render, staticRenderFns } from "./listaEvento.vue?vue&type=template&id=f4ad3c18&scoped=true&"
import script from "./listaEvento.vue?vue&type=script&lang=js&"
export * from "./listaEvento.vue?vue&type=script&lang=js&"
import style0 from "./listaEvento.vue?vue&type=style&index=0&id=f4ad3c18&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f4ad3c18",
  null
  
)

export default component.exports